import 'bootstrap';
import 'admin-lte/dist/css/adminlte.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faSearch, faAngleUp, faAngleDown, faImages, faCartPlus, faTimes, faCheck, faCloudUploadAlt, faListAlt, faFile, faPrint, faClock, faArrowAltCircleLeft, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import datePicker from 'vue-bootstrap-datetimepicker';
//import { VueReCaptcha } from 'vue-recaptcha-v3';

import axios from 'axios';
import router from '@/router'

import '@/assets/css/main.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import 'admin-lte/dist/js/adminlte.min.js'

library.add(faArrowLeft)
library.add(faSearch)
library.add(faAngleUp)
library.add(faAngleDown)
library.add(faImages)
library.add(faTimes)
library.add(faCheck)
library.add(faCloudUploadAlt)
library.add(faListAlt)
library.add(faFile)
library.add(faPrint)
library.add(faCartPlus)
library.add(faClock)
library.add(faArrowAltCircleLeft)
library.add(faFilter)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(datePicker);

miniToastr.init()

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
//Vue.use(VueReCaptcha, { siteKey: '6LfX3MsZAAAAAJFkaQjq7usujvdTSC9_18foBUTb' })
// axios.defaults.baseURL = 'http://localhost:8004'

axios.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401) {
    window.location.href = '/'
  } else {
    return Promise.reject(error)
  }
})

/*
axios.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
      return res;
  },
  async (error) => {
    const originalConfig = error.config;

    if (error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const token = TokenService.getAccessToken();

          if (token) {
            const rs = await axios.post('/admin.php/sesion/refresh_token');

            if (rs.data) {
              TokenService.setAccessToken(rs.data);
            } else {
              TokenService.removeAccessToken()
              window.location.href = '/login/'
            }
          } else {
            window.location.href = '/login/'
          }

          return axios(originalConfig);
          
        } catch (_error) {
          TokenService.removeAccessToken();

          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (error.response.status === 403) {
        TokenService.removeAccessToken();
        return Promise.reject(error.response.data);
      }
    }
    
    return Promise.reject(error);
  }
)
*/

Vue.config.productionTip = false
Vue.prototype.UrlBase = '/guia.php';
Vue.prototype.UrlAdmin = '/admin.php';

new Vue({
  router,
  render: h => h(App),
  data: () => ({
    menu: [],
    modulos: [],
    usuario: null,
    chat: false
  }),
  methods: {
    getMenu () {
      axios
      .get(`${this.UrlAdmin}/modulo/get_menu/56`)
      .then(response => {
        if (response.data.exito) {
          this.menu = response.data.menu
          this.modulos = response.data.modulos
          this.generarRutas()
        } else {
          alert(response.data.mensaje)
        }
      })
      .catch(e => {
        alert(e)
      })
    },
    getUsuario() {
      axios
      .get(`${this.UrlBase}/catalogo/get_info_usuario`)
      .then(res => {
        this.usuario = res.data.usuario;
      }).catch(e => {
        alert('Usuario ' + e);
      });
    },
    generarRutas () {
      this.menu.forEach(obj => {
        let sub = this.rutaBase(obj.nmenu)
        obj.opciones.forEach(op => {
          this.agregarRuta(sub, op)
        })
      })
    },
    agregarRuta(sub, op) {
      let nom = this.rutaNombre(op.nmenu)
      
      this.$router.addRoute({
        path: `/${sub}/${nom}`,
        name: op.weblink,
        component: () => import(`@/components/${op.weblink}.vue`),
        props: { entity_type_id: op.menu }
      })
    },
    rutaBase: txt => {
      return txt.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g,"")
      .slice(0, 3)
    },
    rutaNombre: txt => {
      return txt.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g,"")
      .replace(' ', '_')
    }
  },
  created () {
    console.log('Inicio app c807 express');
  },
  mounted () {
    this.getMenu()
    this.getUsuario()
  }
}).$mount('#app')
